import { createSelector } from '@reduxjs/toolkit';

const selectRoot = state => state?.mqttQueuedMessages;

export const selectQueuedMessages = createSelector(selectRoot, state => state?.messages ?? {});
